// import $ from 'jquery';
// import { gsap } from 'gsap';

// ----------- INCLUDE ALL THE WIDGETS ---------------------//
//import geoLocation                  from './widgets/geoLocation';
import gdprBar                      from './widgets/gdprBar';
import slideshowCtrl                from './widgets/slideshowCtrl';
//import homePromos                   from './widgets/homePromos';
//import locationSlider               from './widgets/locationSlider';
//import locationSplideSlider         from './widgets/locationSplideSlider';

// import slideshowHorizontalScroll    from './widgets/slideshowHorizontalScroll';
// import slideshowWipe                from './widgets/slideshowWipe';
// import slideshowSimple              from './widgets/slideshowSimple';
// import slideshowWide                from './widgets/slideshowWide';
// import moduleSlideshowVariableWidth from './widgets/moduleSlideshowVariableWidth';
import accordion                    from './widgets/accordion';
import videoPlayer                  from './widgets/videoPlayer';
import videoEmbedPlayer             from './widgets/videoEmbedPlayer';
//import audioPlyrPlayer              from './widgets/audioPlyrPlayer';
// import audioPlayer                  from './widgets/audioPlayer';
// import selectCtrl                   from './widgets/selectCtrl';
// import widgetMenuMore               from './widgets/widgetMenuMore';
// import clampReadMore                from './widgets/clampReadMore';
import readMore                     from './widgets/readMore';
//import popUpWindow                  from './widgets/popUpWindow';
//import newsletterPopUpWindow        from './widgets/newsletterPopUpWindow';
//import widowsAndOrphans             from './widgets/widowsAndOrphans';

import Packery                      from 'packery';

// import overlayMessage               from './widgets/overlayMessage';
import videoWindow                  from './widgets/videoWindow';
// import myEmmaNewsletterForm         from './widgets/myEmmaNewsletterForm';
//import mailchimpNewsletterForm      from './widgets/mailchimpNewsletterForm';
// import mapGuide                     from './widgets/mapGuide';
//import imageGalleryOverlay          from './widgets/imageGalleryOverlay';
// import moduleTabs                   from './widgets/moduleTabs';
// import moduleAnchorMenu             from './widgets/moduleAnchorMenu';
// import moduleHistory                from './widgets/moduleHistory';
// import moduleSubmenuPages           from './widgets/moduleSubmenuPages';
// import weatherApi                   from './widgets/weatherApi';
// import gravityFormsControl          from './widgets/gravityFormsControl';
//import widgetDraggableLayer         from './widgets/widgetDraggableLayer';
// import moduleGridFilter             from './widgets/moduleGridFilter';
// import loadNextAjax                 from './widgets/loadNextAjax';
import imageControlSize             from './widgets/imageControlSize';
// import artistsHover                 from './widgets/artistsHover';
// import shopifyCtrl                  from './widgets/shopifyCtrl';
// import widgetShare                  from './widgets/widgetShare';
//import overlayWindow                from './widgets/overlayWindow';
// import beforeAfter                  from './widgets/beforeAfter';
// import dataGraphicScroll            from './widgets/dataGraphicScroll';
// import imageTooltips                from './widgets/imageTooltips';
// import switchToggle                 from './widgets/switchToggle';

import homeControl                  from './widgets/homeControl';
import homeLandingControl                  from './widgets/homeLandingControl';
import directorsControl             from './widgets/directorsControl';
import thumbnailsControl             from './widgets/thumbnailsControl';

export default class WIDGETS{

    constructor(options) {

        this.defaults = {
        	main : undefined
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = 'widgets';
		this.main = this.options.main;
        this.$body  = $('body');
        
        this.GEO = undefined;

        this.commercialsFirstTime = true;
        this.brandedFirstTime = true;

        this._firstTime = {
            'page-id-7' : true,
            'page-id-9' : true,
            'page-id-901' : true,
            'page-id-902' : true,
            'page-id-906' : true,
            'page-id-907' : true            
        };

        // this.audioPlayer = undefined;
        // this.videoWindow = undefined;
    }

	initWidgets($context, b, firstTime){


        
  //        this.initOverlayMessage( b, $context );
		this.initSlideShows( b, $context );
        // this.initLocationSlider( b, $context );
        // this.initSplideLocationSlider( b, $context );



  //    this.initSlideshowHorizontalScroll( b, $context );
        // this.initPopUpWindows( b, $context, false );
        
        this.initVideoPlayer( b, $context );
        this.initVideoEmbedPlayer( b, $context );
        this.initPackeryGrids(  b, $context );
        // this.initAudioPlayer( b, $context );
  //       this.initForms( b, $context );
  //       this.initMisc( b, $context );
        //this.initClamps( b, $context );
        this.initReadMore( b, $context );
        this.initAccordion( b, $context );
        // this.initWidowsAndOrphans( b );
  //       this.disableContextMenu( b );
  //       this.initAudioTriggers( b, $context );
        this.initVideoTriggers( b, $context );
  //       this.initNewsletterForm( b, $context );
  //       this.initMapGuide( b, $context );
        // this.initImageGalleryOverlay( b, $context );
  //       this.initModuleTabs( b, $context );
  //       this.initAnchorMenu( b, $context );
  //       this.initModuleHistory( b, $context );
  //       this.initModuleSubmenuPages( b, $context );
  //       this.initMobileSelect( b, $context );
  //       this.initFilterSelect( b, $context );
        // this.initWidgetDraggableLayer( b, $context );
  //       this.initModuleGridFilter( b, $context );
  //       this.initLoadNextAjax( b, $context );
  //       this.ajaxifyGravityForms( b, $context );
        this.initImageControlSize( b, $context );

        //this.initBeforeAfter( b, $context );

        //this.initDataGraphicScroll( b, $context );

        //this.initContactForms( b, $context );

        //this.initWidgetShare( b, $context );
        // this.initOverlayWindow( b, b?$context:false );
        //this.initImageTooltips( b, $context );
        // this.initSwitchToggle( b, b?$context:false );

        //this.initVideoWindow( b, $context );

        if ( this.$body.hasClass( 'home' ) ){
            this.initHomeControl( b, $context );
        }
        if ( this.$body.hasClass( 'page-template-home-landing' ) ){
            this.initHomeLandingControl( b, $context );
        }
        

        /*
        if ( this.$body.hasClass( 'page-id-7' ) || this.$body.hasClass( 'page-id-9' ) ){

            let firstTime = false;

            if ( b ){
                firstTime = this.$body.hasClass( 'page-id-7' ) ? this.commercialsFirstTime : this.brandedFirstTime;
            }


            this.initDirectorsControl( b, $context, firstTime  );

            if ( b ){
                if ( this.$body.hasClass( 'page-id-7' ) ){
                    this.commercialsFirstTime = false;
                }
                else{
                    this.brandedFirstTime = false;
                }
            }

        }
        */

        if ( this.$body.hasClass( 'page-template-directors-landing' ) ){
            let firstTime = false, ids = [7,9,901,902,906,907], i, id;

            if ( b ){

                //firstTime = this.$body.hasClass( 'page-id-7' ) ? this.commercialsFirstTime : this.brandedFirstTime;

                for( i=0; i<ids.length; i++ ){
                    id = 'page-id-'  + ids[ i ];
                    if ( this.$body.hasClass( id ) ){
                        firstTime = this._firstTime[ id ];
                    }
                }
            }


            this.initDirectorsControl( b, $context, firstTime  );

            if ( b ){

                /*
                if ( this.$body.hasClass( 'page-id-7' ) ){
                    this.commercialsFirstTime = false;
                }
                else{
                    this.brandedFirstTime = false;
                }
                */
                for( i=0; i<ids.length; i++ ){
                    id = 'page-id-'  + ids[ i ];
                    if ( this.$body.hasClass( id ) ){
                        this._firstTime[ id ] = false;
                    }
                }                
            }
        }

        this.initThumbnailsControl( b, $context );



        // widgets initialized only one time, when page load !!!
        if ( firstTime ){
            // this.initNewsletterForm( b, $context );
            this.initGdprBar();
            // this.initNewsletterPopUpWindows( b, $context, true );
            // this.initWeatherApi();
            // this.initPopUpWindows( b, $context, true );
            this.initVideoWindow( b, $context );
            // this.initAudioPlayer( b, $context );
            // this.initGravityForms();

            //this.initGEOLocation();
        }

	}

    /*
    initContactForms( b, $context ){
        let $el;

        $el = $context ? $context.find( '.wpcf7 > form' ) : $('.wpcf7 > form');

        if ( $el.length > 0 ){
            if ( b ){
                $el.each( (i, el) => {
                     wpcf7.init( el );
                } )
            }
        }

    }
    */

    /*
    initOverlayMessage(b, $context){
        let $el, $s, c;

        $el = $context ? $context.find( '.video-container-home .overlay-message' ) : $('.video-container-home .overlay-message');

        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new overlayMessage({
                        $el: $s
                    });
                    // set the Class instance reference.
                    this.assign( $s, c );
                })
            }
            else{
                this.destroy( $el )
            }
        }
    }
    */
    
    //------------------------------------ SLIDESHOWS -----------------------------------------------------------------//
    initSlideShows(b, $context){
    	let $el, $s, c;

        //---------- Slideshow ------------//
        
        $el = $context ? $context.find( '.module_slideshow' ) : $('.module_slideshow');
        if ( $el.length > 0 && !$el.hasClass( 'module-slideshow-variable-width' ) ){
            if ( b ){
                $el.each( (i, el) => {

                	$s = $(el);
                	   
                    // Make sure this has not already been init.
                    // if ( $s.hasClass('slideshow-ctrl-init') ) return;

                    if ( ! $s.hasClass( 'manual-init' ) ){
                    	let o = {
	                    	fade : $s.hasClass( 'option-slide' ) ? false :  true,
	                    	autoplay: $s.hasClass( 'autoplay' ),
	                        dots: !$s.hasClass( 'no_dots' ),
	                        arrows: $s.hasClass( 'arrows' ),
	                        // responsive: !$s.hasClass( 'no-responsive' ),
	                        adaptiveHeight: $s.hasClass( 'adaptive-height' ),
	                        delayAutoplay: i*2000,

                            pauseOnHover: $s.hasClass( 'pause-on-hover' ),

                            responsive: [
                                {
                                  breakpoint: 767,
                                  settings: {
                                        arrows: false,
                                        fade: false
                                  }
                                }
                            ]


	                    };

	                    // if specify autoplay speed (see home )
	                    if ( $s.attr( 'data-time-autoplay' ) ){
	                    	o.autoplaySpeed = parseFloat( $s.attr( 'data-time-autoplay' ) ) * 1000;
	                    }
	                    if ( $s.attr( 'data-speed' ) ){
	                    	o.speed = parseFloat( $s.attr( 'data-speed' ) ) * 1000;
	                    }

	                    if ( $s.attr( 'data-as-nav' ) ){
	                    	o.asNavFor = '.' + $s.attr( 'data-as-nav' );
	                    }

	                    if ( $s.attr( 'data-is-nav' ) ){
	                    	o.centerMode = false;
	                    	o.slidesToShow = $s.find( '.slick-slide' ).length;
	                    	o.infinite = false;
	                    	o.focusOnSelect = true;
	                    }

	                    if ( $s.hasClass( 'is-finite' ) ){
	                    	o.infinite = false;
	                    }

	                    if ( $s.hasClass( 'arrows' ) ){
  							o.arrows = true;
							o.prevArrow = $s.find('.arrow.left');
							o.nextArrow = $s.find('.arrow.right');
						}

                        if ( $s.hasClass( 'crossfade' ) ){
                            o.crossFade = true;
                        }

						// important: Remember to pass the dom element!!!
						o.$el = $s;
	                    c = new slideshowCtrl( o );
	                    // set the Class instance reference.
	                    this.assign( $s, c );

                    }

                	// ------------------------ MANUAL INIT :: SPECIAL CASES ---------------------------//
                    /*
                    if ( $s.hasClass( 'slideshow-related-people' ) ){
                        let args = {
                            infinite: true,
                            slidesToScroll: 4,
                            slidesToShow: 4,
                            centerMode: false,
                            variableWidth: false,
                            //centerPadding: '0px',
                            dots: false,
                            arrows: false,
                            prevArrow : $s.find('.arrow.left'),
                            nextArrow : $s.find('.arrow.right'),
                            
                            responsive: [
                                {
                                  breakpoint: 1023,
                                  settings: {
                                    arrows: true,
                                    slidesToShow: 2,
                                    slidesToScroll: 2,
                                    centerMode: true,
                                  }
                                },
                                {
                                  breakpoint: 767,
                                  settings: {
                                    arrows: true,
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                  }
                                },
                            ]
                        }
                        // important: Remember to pass the dom element!!!
                        c = new slideshowCtrl( {
                            $el : $s,
                            customArgs: true,
                            args: args
                        } );
                        // set the Class instance reference.
                       this.assign( $s, c );


                    } 
                    */

                    /*
                    if ( $s.hasClass( 'slideshow-related' ) ){


                        let args = {
                            infinite: true,
                            slidesToScroll: 1,
                            slidesToShow: 5,
                            centerMode: false,
                            variableWidth: false,
                            dots: false,
                            arrow: false,
                            
                            // tablet and mobile variableWidth = true (the size is determined by the css)
                            responsive: [
                                {
                                  breakpoint: 1023,
                                  settings: {
                                    arrows: false,
                                    slidesToShow: 3,
                                    variableWidth: true
                                  }
                                },
                                {
                                  breakpoint: 767,
                                  settings: {
                                    arrows: false,
                                    slidesToShow: 1,
                                    variableWidth: true
                                  }
                                }
                            ]
                        }
                        // important: Remember to pass the dom element!!!
                        c = new slideshowCtrl( {
                            $el : $s,
                            customArgs: true,
                            args: args
                        } );
                        // set the Class instance reference.
                       this.assign( $s, c );

                    }
                    */

                    /*
                    if ( $s.hasClass( 'slideshow-related-small' ) ){


                        let args = {
                            infinite: true,
                            slidesToScroll: 1,
                            slidesToShow: 3,
                            centerMode: false,
                            variableWidth: false,
                            dots: false,
                            arrow: false,
                            
                            // tablet and mobile variableWidth = true (the size is determined by the css)
                            responsive: [
                                {
                                  breakpoint: 1023,
                                  settings: {
                                    arrows: false,
                                    slidesToShow: 3,
                                    variableWidth: true
                                  }
                                },
                                {
                                  breakpoint: 767,
                                  settings: {
                                    arrows: false,
                                    slidesToShow: 1,
                                    variableWidth: true
                                  }
                                }
                            ]
                        }
                        // important: Remember to pass the dom element!!!
                        c = new slideshowCtrl( {
                            $el : $s,
                            customArgs: true,
                            args: args
                        } );
                        // set the Class instance reference.
                       this.assign( $s, c );

                    }
                    */

                    /*
                    if ( $s.hasClass( 'slideshow-project-related-content' ) ){


                        let args = {
                            infinite: true,
                            slidesToScroll: 1,
                            slidesToShow: 3,
                            centerMode: false,
                            variableWidth: false,
                            dots: false,
                            arrow: false,
                            
                            // tablet and mobile variableWidth = true (the size is determined by the css)
                            responsive: [
                                {
                                  breakpoint: 1023,
                                  settings: {
                                    arrows: false,
                                    slidesToShow: 3,
                                    variableWidth: true
                                  }
                                },
                                {
                                  breakpoint: 767,
                                  settings: {
                                    arrows: false,
                                    slidesToShow: 1,
                                    variableWidth: true
                                  }
                                }
                            ]
                        }
                        // important: Remember to pass the dom element!!!
                        c = new slideshowCtrl( {
                            $el : $s,
                            customArgs: true,
                            args: args
                        } );
                        // set the Class instance reference.
                       this.assign( $s, c );

                    }
                    */

                    /*
                    if ( $s.hasClass( 'slideshow-module-about' ) ){
                        let args = {
                            infinite: true,
                            slidesToScroll: 1,
                            slidesToShow: 1,
                            centerMode: false,
                            variableWidth: false,
                            dots: true,
                            arrows: false,
                            fade: true,
                            responsive: [
                                {
                                    breakpoint: 767,
                                    settings: {
                                        fade: false
                                    }
                                }
                            ]
                        }
                        // important: Remember to pass the dom element!!!
                        c = new slideshowCtrl( {
                            $el : $s,
                            customArgs: true,
                            args: args
                        } );
                        // set the Class instance reference.
                       this.assign( $s, c );
                    }
                    */

                });
            }
            else{
				this.destroy( $el )            	
            }
        }


        //---------- SLIDESHOW HOME PROMOS --------//
        /*
        $el = $('.module-slideshow-home-promos');
        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new moduleSlideshowHomePromos({
                        $el: $s,
                        main: this.main
                    });
                    // set the Class instance reference.
                    this.assign( $s, c );
                })
            }
            else{
                this.destroy( $el )
            }
        }
        */


        //---------- SLIDESHOW WIPE --------//
        /*
        $el = $('.module_slideshow_wipe');
        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new slideshowWipe({
                    	$el: $s,
					    time_t_on: 1,
					    time_t_off: 0.7,
					    time_between_slides: 5000,
					    pauseOnHover: false,
					    image_mode: 'cover', //'contain', //'constant_height',
					    fade: i===1	                    	
                    });
                    // set the Class instance reference.
                    this.assign( $s, c );
                })
            }
            else{
                this.destroy( $el )
            }
        }
        */

        //---------- SLIDESHOW SIMPLE --------//
        /*
        $el = $('.slider-simple-fade');
        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new slideshowSimple({
                        $el: $s,
                        time_t_on: 0.9,
                        time_t_off: 0.7,
                        time_between_slides: 2000,
                        pauseOnHover: false
                    });
                    // set the Class instance reference.
                    this.assign( $s, c );
                })
            }
            else{
                this.destroy( $el )
            }
        }
        */

        //---------- SLIDESHOW WIDE --------//
        /*
        $el = $('.slideshow-wide');
        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new slideshowWide({
                        $el: $s,
                        main: this.main
                   });
                    // set the Class instance reference.
                    this.assign( $s, c );
                })
            }
            else{
                this.destroy( $el )
            }
        }
        */

        //---------- SLIDESHOW VARIABLE WIDTH --------//
        /*
        $el = $('.module-slideshow-variable-width');
        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new moduleSlideshowVariableWidth({
                        $el: $s,
                        main: this.main
                    });
                    // set the Class instance reference.
                    this.assign( $s, c );
                })
            }
            else{
                this.destroy( $el )
            }
        }
        */
    }

    /*
    initSlideshowHorizontalScroll( b, $context ){
        let $el = $context ? $context.find( '.slideshow-horizontal-scroll' ) : $('.slideshow-horizontal-scroll'), 
        $s, c;      
        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new slideshowHorizontalScroll({
                        $el: $s
                        ,main: this.main
                    });
                    // set the Class instance reference.
                    this.assign( $s, c );
                })          
            }
            else{
                this.destroy( $el )
            }
        }
    }
    */


    initHomeControl( b, $context ){

        let $el = $context ? $context.find( '.backgrounds-home-control' ) : $( '.backgrounds-home-control' ), 
        $s, c;
        

        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new homeControl({
                        $el: $s
                        ,main: this.main
                    });
                    this.assign( $s, c );
                })          
            }
            else{
                this.destroy( $el )
            }
        }

    }

    initHomeLandingControl( b, $context ){

        let $el = $context ? $context.find( '.home-landing-controls' ) : $( '.home-landing-controls' ), 
        $s, c;
        

        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new homeLandingControl({
                        $el: $s
                        ,main: this.main
                    });
                    this.assign( $s, c );
                })          
            }
            else{
                this.destroy( $el )
            }
        }

    }

    initDirectorsControl( b, $context, firstTime ){

        let $el = $context ? $context.find( '.directors-control' ) : $( '.directors-control' ), 
        $s, c, commercials;

        if ( $el.length > 0 ){

            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new directorsControl({
                        $el: $s
                        ,main: this.main
                        ,firstTime: firstTime
                    });
                    this.assign( $s, c );
                })          
            }
            else{
                this.destroy( $el )
            }
        }

    }

    initThumbnailsControl( b, $context ){

        let $el = $context ? $context.find( '.image-for-video ' ) : $( '.image-for-video ' ), 
        $s, c, commercials;

        if ( $el.length > 0 ){

            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new thumbnailsControl({
                        $el: $s
                        ,main: this.main
                    });
                    this.assign( $s, c );
                })          
            }
            else{
                this.destroy( $el )
            }
        }

    }

    /*
    initLocationSlider( b, $context ){

        let $el = $context ? $context.find( '.module-locations-slider' ) : $('.module-locations-slider'), 
        $s, c;
        
        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new locationSlider({
                        $el: $s
                        ,main: this.main
                        ,$arrow_l:      $s.find( '.swiper-controls .prev' )
                        ,$arrow_r:      $s.find( '.swiper-controls .next' )
                    });
                    this.assign( $s, c );
                })          
            }
            else{
                this.destroy( $el )
            }
        }

    }
    */

    /*
    initSplideLocationSlider( b, $context ){

        let $el = $context ? $context.find( '.module-locations-slider' ) : $('.module-locations-slider'), 
        $s, c;
        
        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new locationSplideSlider({
                        $el: $s
                        ,main: this.main
                        ,$arrow_l:      $s.find( '.swiper-controls .prev' )
                        ,$arrow_r:      $s.find( '.swiper-controls .next' )
                    });
                    this.assign( $s, c );
                })          
            }
            else{
                this.destroy( $el )
            }
        }

    }
    */

    //-------------------------------------------------- VIDEO PLAYER ---------------------------------------------------------------//
    initVideoPlayer( b, $context ){
    	let $el = $context ? $context.find( '.video-player' ) : $('.video-player'), 
    	$s, c;    	
    	if ( $el.length > 0 ){
	    	if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new videoPlayer({
                    	$el: $s
                    	,main: this.main
                    	,background: $s.hasClass( 'video-background' )
                    	,autoplay: $s.hasClass( 'video-autoplay' )
                    	,playPause:  $s.hasClass( 'video-play-pause')
                        ,autopause: $s.hasClass( 'video-autopause' )
                        ,pauseOnStart: $s.hasClass( 'video-pause-on-start' )


                        ,trackGAEvents: false
                    });
                    // set the Class instance reference.
                    //$s.data('widget', c );
                    this.assign( $s, c );
                })	    	
            }
	    	else{
	    		this.destroy( $el )
	    	}
    	}
    }

    //-------------------------------------------------- AUDIO  PLYR PLAYER ---------------------------------------------------------------//
    /*
    initAudioPlayer( b, $context ){
        let $el = $context ? $context.find( '.audio-plyr-player' ) : $('.audio-plyr-player'), 
        $s, c;      
        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new audioPlyrPlayer({
                        $el: $s
                        ,main: this.main
                     });
                    // set the Class instance reference.
                    //$s.data('widget', c );
                    this.assign( $s, c );
                })          
            }
            else{
                this.destroy( $el )
            }
        }
    }
    */

    //-------------------------------------------------- VIDEO EMBED PLAYER ---------------------------------------------------------------//
    initVideoEmbedPlayer( b, $context ){
        let $el = $context ? $context.find( '.video-embed-player' ) : $('.video-embed-player'), 
        $s, c;      
        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new videoEmbedPlayer({
                        $el: $s
                        ,main: this.main
                     });
                    // set the Class instance reference.
                    //$s.data('widget', c );
                    this.assign( $s, c );
                })          
            }
            else{
                this.destroy( $el )
            }
        }
    }


    //-------------------------------------------------- PACKERY GRIDS -------------------------------------------------------//
    initPackeryGrids( b, $context ){
        let $el = $context ? $context.find( '.grid-packery' ) : $('.grid-packery'), 
        $s, c;
        
        //----------------------------- selects -----------------------//
        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new Packery( $(el)[0], {
                        itemSelector: '.item-grid',
                        percentPosition: true,
                        gutter: '.gutter-sizer',
                        transitionDuration: '0' //'0.4s'           
                    });
                    this.assign( $s, c );
                    $s.addClass('packed' );
                })          
            }
            else{
                this.destroy( $el )
            }
        }
    }

    //-------------------------------------------------- FORMS ---------------------------------------------------------------//
    /*
    initForms( b, $context ){
        let $el = $context ? $context.find( 'select.url-select' ) : $('select.url-select'), 
        $s, c;
        
        //----------------------------- selects -----------------------//
        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new selectCtrl({
                        $el: $s
                        ,main: this.main
                    });
                    this.assign( $s, c );
                })          
            }
            else{
                this.destroy( $el )
            }
        }
    }
    */

    /*
    initMisc( b, $context ){
        let $el = $context ? $context.find( '.widget-menu-more' ) : $('.widget-menu-more'), 
        $s, c;
        
        //----------------------------- widgetMenuMore -----------------------//
        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new widgetMenuMore({
                        $el: $s
                        ,main: this.main
                    });
                    this.assign( $s, c );
                })          
            }
            else{
                this.destroy( $el )
            }
        }
    }
    */

    
    //----------------------------------------------- Newsletter Form ---------------------------------------------------------------//
    /*
    initNewsletterForm( b, $context ){

        //console.log('initNewsletterForm');

        let $el = $context ? $context.find( '.mailchimp-newsletter-form' ) : $('.mailchimp-newsletter-form'), 
        $s, c;
        
        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new mailchimpNewsletterForm({
                        $el: $s
                        ,main: this.main
                        ,active: true
                    });
                    this.assign( $s, c );
                })          
            }
            else{
                this.destroy( $el )
            }
        }

    }
    */

    //----------------------------------------------- SwitchToggle ---------------------------------------------------------------//
    /*
    initSwitchToggle( b, $context ){

        let $el = $context ? $context.find( '.switch-toggle' ) : $('.switch-toggle'), 
        $s, c;
        
        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new switchToggle({
                        $el: $s
                        ,main: this.main
                    });
                    this.assign( $s, c );
                })          
            }
            else{
                this.destroy( $el )
            }
        }

    }
    */

    // initNewsletterForm( b, $context ){
    //     let $el = $context ? $context.find( '.myemma-newsletter-form' ) : $('.myemma-newsletter-form'), 
    //     $s, c;
        
    //     if ( $el.length > 0 ){
    //         if ( b ){
    //             $el.each( ( i, el ) =>{
    //                 $s = $(el);
    //                 c = new myEmmaNewsletterForm({
    //                     $el: $s
    //                     ,main: this.main,
    //                     active: true
    //                 });
    //                 this.assign( $s, c );
    //             })          
    //         }
    //         else{
    //             this.destroy( $el )
    //         }
    //     }
    // }

    //-------------------------------------------------- CLAMPS ---------------------------------------------------------------//
    /*
    initClamps( b, $context ){
        let $el = $context ? $context.find( '.clamp' ) : $('.clamp'), 
        $s, c;
        
        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new clampReadMore({
                        $el: $s
                        ,main: this.main
                        ,lines : $s.attr('data-lines') ? parseInt($s.attr('data-lines')) : 2
                        ,readmore : $s.hasClass( 'add-read-more' )
                        ,formatText: $s.hasClass( 'format-p' )
                    });
                    this.assign( $s, c );
                })          
            }
            else{
                this.destroy( $el )
            }
        }
    }
    */

    //-------------------------------------------------- ACCORDION -----------------------------------------------------------//
    initAccordion( b, $context ){
        let $el = $context ? $context.find( '.module-accordion' ) : $('.module-accordion'), 
        $s, c;
        
        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new accordion({
                        $el: $s
                    });
                    this.assign( $s, c );
                })          
            }
            else{
                this.destroy( $el )
            }
        }
    }

    //-------------------------------------------------- BEFORE/AFTER -----------------------------------------------------------//
    /*
    initBeforeAfter( b, $context ){
        let $el = $context ? $context.find( '.widget-before-after' ) : $('.widget-before-after'), 
        $s, c;
        
        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new beforeAfter({
                        $el: $s
                        ,main: this.main
                    });
                    this.assign( $s, c );
                })          
            }
            else{
                this.destroy( $el )
            }
        }
    }
    */

    //-------------------------------------------------- DATA GRAPHIC SCROLL -----------------------------------------------------------//
    /*
    initDataGraphicScroll( b, $context ){
        let $el = $context ? $context.find( '.widget-data-graphic-scroll' ) : $('.widget-data-graphic-scroll'), 
        $s, c;
        
        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new dataGraphicScroll({
                        $el: $s,
                        index: i,
                        main: this.main,
                    });
                    this.assign( $s, c );
                })          
            }
            else{
                this.destroy( $el )
            }
        }
    }
    */

    //-------------------------------------------------- READ MORE -----------------------------------------------------------//
    initReadMore( b, $context ){
        let $el = $context ? $context.find( '.widget-read-more' ) : $('.widget-read-more'), 
        $s, c;
        
        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new readMore({
                        $el: $s
                        ,main: this.main
                        ,text_more: $s.attr( 'data-more' )
                        ,text_less: $s.attr( 'data-less' )

                        ,default_state_open : $s.attr( 'data-default-state-open')
                    });
                    this.assign( $s, c );
                })          
            }
            else{
                this.destroy( $el )
            }
        }
    }

    //-------------------------------------------------- POPUP WINDOWS -------------------------------------------------------//
    /*
    initPopUpWindows( b, $context, is_global ){

        if ( !b ){
            // Pop Up Windows when initialized is attached to body to be on top of everything. So when destroy look to the body.
            $context = false;
        }

        let $el = $context ? $context.find( '.popup-window' ) : $('.popup-window'), 
        $s, c, o;
        
        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    o = {
                        $el: $s,
                        $trigger: $('a.popup-window-trigger'),
                        main: this.main,
                        global: is_global,
                        forceOpen: false                    
                    }
                    c = new popUpWindow( o );
                    this.assign( $s, c );
                })          
            }
            else{
                this.destroy( $el )
            }
        }
    }
    */

    /*
    initNewsletterPopUpWindows( b, $context, is_global ){

        if ( !b ){
            // Pop Up Windows when initialized is attached to body to be on top of everything. So when destroy look to the body.
            $context = false;
        }

        let $el = $context ? $context.find( '.newsletter-popup-window' ) : $('.newsletter-popup-window'), 
        $s, c, o;
        
        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    o = {
                        $el: $s,
                        main: this.main,
                        global: is_global               
                    }
                    c = new newsletterPopUpWindow( o );
                    this.assign( $s, c );
                })          
            }
            else{
                this.destroy( $el )
            }
        }
    }
    */

    /*
    initArtistsPage( b, $context ){

        let $el = $context ? $context.find( '.artists-hover' ) : $('.artists-hover'), 
        $s, c, o;

        if ( $el.length > 0 ){

            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    o = {
                        $el: $s,
                        main: this.main,
                    }
                    c = new artistsHover( o );
                    this.assign( $s, c );
                })          
            }
            else{
                this.destroy( $el )
            }
        }
    }
    */

    /*
    initShopifyCtrl( b, $context ){

        let $el = $context ? $context.find( '.shopify-ctrl' ) : $('.shopify-ctrl'), 
        $s, c, o;

        if ( $el.length > 0 ){

            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    o = {
                        $el: $s,
                        main: this.main,
                    }
                    c = new shopifyCtrl( o );
                    this.assign( $s, c );
                })          
            }
            else{
                this.destroy( $el )
            }
        }
    }
    */

    //-------------------------------------------------- READ MORE -----------------------------------------------------------//
    /*
    initWidowsAndOrphans( b ){
        let $s, c;
        $s = $('body');
        if ( b ){
            c = new widowsAndOrphans({
                main: this.main
                , classes: [ '.widow' ]
            });
            this.assign( $s, c );         
        }
        else{
            this.destroy( $s )
        }
    }
    */

    /*
    disableContextMenu( b ){
        if ( b ){
            $('img').on('contextmenu', function(e){
                e.preventDefault();
                return false;
            }); 
        }
        else{
            $('img').on('contextmenu', function(e){
                e.preventDefault();
                return false;
            }); 
        }
    }
    */

    //-------------------------------------------------- AUDIO PLAYER ---------------------------------------------------------------//
    /*
    initAudioPlayer( b, $context ){
        let $el = $context ? $context.find( '.audio-player' ) : $('.audio-player');
        
        if ( $el.length > 0 ){
            if ( b ){
                //$el.each( ( i, el ) =>{
                    //$s = $(el);
                    this.audioPlayer = new audioPlayer({
                        $el: $el
                        //src: $s.attr( 'data-audio-src' ).split(',')
                    });
                    // set the Class instance reference.
                    //$s.data('widget', c );
                //})          
            }
            else{
                //this.destroy( $el )
            }
        }
    }

    initAudioTriggers( b, $context ){
        let $el = $context ? $context.find( '.open-audio-player' ) : $('.open-audio-player');
        if ( $el.length > 0 ){
            if ( b ){
                $el.on( 'click', (e)=>{ this.playAudio(e); } );
            }
            else{
                $el.off( 'click', (e)=>{ this.playAudio(e); } );
            }
        }

        // item grid, title and images are linkable too
        $el = $context ? $context.find( '.item-grid .trigger-open-audio-player' ) : $('.item-grid .trigger-open-audio-player');
        if ( $el.length > 0 ){
            if ( b ){
                $el.on( 'click', (e)=>{

                    e.preventDefault();
                    $el = $(e.currentTarget).parents( '.item-grid' );
                    if ( $el.length > 0 ){
                        $el.find( 'a.open-audio-player' ).click();
                    }

                } );
            }
            else{
                $el.off( 'click' );
            }
        }
    }

    playAudio( e ){
        let $s, src;
        e.preventDefault();
        $s = $(e.currentTarget);
        src = $s.attr( 'data-audio-src' );
        if ( src && this.audioPlayer && !$s.hasClass( 'is-playing' ) ){
            this.audioPlayer.playSound( src, {
                title: $s.find( '.title' ).text(), // $s.attr( 'data-title' ),
                author: $s.attr( 'data-author' ),
                $btn: $s
            } );
        }
    }
    */

    //--------------------------------------------------- VIDEO WINDOW ----------------------------------------------------------//
    
    initVideoWindow( b, $context ){
        let $el = $context ? $context.find( '.video-window' ) : $('.video-window');
        
        if ( $el.length > 0 ){
            if ( b ){
                //$el.each( ( i, el ) =>{
                    //$s = $(el);
                    this.videoWindow = new videoWindow({
                        $el: $el,
                        main: this.main
                        //src: $s.attr( 'data-audio-src' ).split(',')
                    });
                    // set the Class instance reference.
                    //$s.data('widget', c );
                //})          
            }
            else{
                //this.destroy( $el )
            }
        }
    }

    initVideoTriggers( b, $context ){
        let $el = $context ? $context.find( '.open-video-window' ) : $('.open-video-window');
        if ( $el.length > 0 ){
            if ( b ){
                $el.on( 'click', (e)=>{ this.videoWindow.triggerWindow(e); } );
            }
            else{
                $el.off( 'click', (e)=>{ this.videoWindow.triggerWindow(e); } );
            }
        }
    }
   

    /*
    initModuleTabs( b, $context ){
        let $el = $context ? $context.find( '.module-tabs' ) : $('.module-tabs'), $s, c;        
        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new moduleTabs({
                        $el: $s,
                        main: this.main
                    });
                    // set the Class instance reference.
                    $s.data('widget', c );
                })          
            }
            else{
                this.destroy( $el )
            }
        }
    }
    */

    /*
    initModuleGridFilter( b, $context ){
        let $el = $context ? $context.find( '.module-grid-filter' ) : $('.module-grid-filter'), $s, c;        
        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new moduleGridFilter({
                        $el: $s,
                        main: this.main
                    });
                    // set the Class instance reference.
                    $s.data('widget', c );
                })          
            }
            else{
                this.destroy( $el )
            }
        }
    }
    */

    /*
    initAnchorMenu( b, $context ){
        let $el = $context ? $context.find( '.module-anchor-menu' ) : $('.module-anchor-menu'), $s, c;        
        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new moduleAnchorMenu({
                        $el: $s,
                        main: this.main
                    });
                    // set the Class instance reference.
                    $s.data('widget', c );
                })          
            }
            else{
                this.destroy( $el )
            }
        }
    }
    */

    /*
    initModuleHistory( b, $context ){
        let $el = $context ? $context.find( '.module-history' ) : $('.module-history'), $s, c;        
        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new moduleHistory({
                        $el: $s,
                        main: this.main
                    });
                    // set the Class instance reference.
                    $s.data('widget', c );
                })          
            }
            else{
                this.destroy( $el )
            }
        }
    }
    */

    /*
    initModuleSubmenuPages( b, $context ){
        let $el = $context ? $context.find( '.submenu-pages-desktop' ) : $('.submenu-pages-desktop'), $s, c;        
        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new moduleSubmenuPages({
                        $el: $s,
                        main: this.main
                    });
                    // set the Class instance reference.
                    $s.data('widget', c );
                })          
            }
            else{
                this.destroy( $el )
            }
        }
    }
    */

    /*
    initMobileSelect( b, $context ){
        let $el = $context ? $context.find( '.trigger-url' ) : $('.trigger-url'), $s, href;        
        if ( $el.length > 0 ){
            if ( b ){
                $el.on( 'change', ( e ) => {
                    $s = $(e.currentTarget);
                    href = $s.val();
                    if ( href ){
                        this.main.barba_triggerURL( href, $s );
                    }
                } );
            }
            else{
                $el.off( 'change' );
            }
        }
    }
    */

    /*
    initFilterSelect( b, $context ){
        let $el = $context ? $context.find( '.select-filter' ) : $('.select-filter'), $s, v, $container, $items, attr, $item;        
        if ( $el.length > 0 ){
            if ( b ){
                $container = $( '.' + $el.attr( 'data-target-container' ) );
                if ( $container.length > 0 ){
                    $items = $container.find( '.' + $el.attr( 'data-target-item' ) );
                    if ( $items.length > 0 ){
                        attr = $el.attr( 'data-target-filter' );
                        $el.on( 'change', ( e ) => {
                            $s = $(e.currentTarget);
                            v = $s.val();


                            gsap.set( $items, {display:'block'} );

                            if ( v === '' ){
                                // all
                            }
                            else{
                                $items.each( (i,el)=>{
                                    $item = $(el);
                                    if ( $item.attr( attr ) !== v ){
                                        gsap.set( $item, {display:'none'} );
                                    }
                                    else{
                                        gsap.set( $item, {display:'block'} );
                                    }
                                });
                            }
                        } );
                    }
                }
            }
            else{
                $el.off( 'change' );
            }
        }        
    }
    */

    /*
    ajaxifyGravityForms( b, $context ){
        let $el = $context ? $context.find( '.gravity-forms-control' ) : $('.gravity-forms-control'), $s, c;
        //scripts;
        
        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new gravityFormsControl({
                        $el: $s,
                        main: this.main
                    });
                    // set the Class instance reference.
                    $s.data('widget', c );
                })          
            }
            else{
                this.destroy( $el )
            }
        }
    }
    */

    /*
    initWidgetDraggableLayer( b, $context ){
        let $el = $context ? $context.find( '.widget-draggable-layer' ) : $('.widget-draggable-layer'), $s, c;

        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new widgetDraggableLayer({
                        $el: $s,
                        main: this.main,
                        marginLeft: 10
                    });
                    $s.data('widget', c );
                })          
            }
            else{
                this.destroy( $el )
            }
        }
       
    }
    */

    /*
    initWidgetShare( b, $context ){
        let $el = $context ? $context.find( '.module-share' ) : $('.module-share'), $s, c;

        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new widgetShare({
                        $el: $s,
                    });
                    $s.data('widget', c );
                })          
            }
            else{
                this.destroy( $el )
            }
        }
       
    }
    */

    /*
    initOverlayWindow( b, $context ){
        let $el = $context ? $context.find( '.overlay-publication' ) : $('.overlay-publication'), $s, c,
            $trigger = $context ? $context.find( '.open-overlay-window' ) : $('.open-overlay-window');
        
        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new overlayWindow({
                        $el: $el,
                        $trigger: $trigger,
                        global: true
                    });
                    // set the Class instance reference.
                    $s.data('widget', c );
                })          
            }
            else{
                this.destroy( $el )
            }
        }
    }
    */

    /*
    initImageGalleryOverlay( b, $context ){

        if ( !b ){
            // Pop Up Windows when initialized is attached to body to be on top of everything. So when destroy look to the body.
            $context = false;
        }

        let $el = $context ? $context.find( '.image-gallery-overlay' ) : $('.image-gallery-overlay'), $s, c;
        
        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new imageGalleryOverlay({
                        $el: $s,
                        $trigger: $('.enlarge-gallery-wrap'),
                        main: this.main
                    });
                    // set the Class instance reference.
                    $s.data('widget', c );
                })          
            }
            else{
                this.destroy( $el )
            }
        }
    }
    */

    /*
    initImageTooltips( b, $context ){

        let $el = $context ? $context.find( '.image-map' ) : $('.image-map'), $s, c;
        
        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new imageTooltips({
                        $el: $s,
                        main: this.main
                    });
                    // set the Class instance reference.
                    $s.data('widget', c );
                })          
            }
            else{
                this.destroy( $el )
            }
        }
    }

    */



    /*
    initLoadNextAjax( b, $context ){
        let $el = $context ? $context.find( '.trigger-load-ajax-content' ) : $('.trigger-load-ajax-content'), $s, c;

        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new loadNextAjax({
                        $el: $s,
                        main: this.main,
                        index: i
                    });
                    $s.data('widget', c );
                }) 
            }
            else{
                this.destroy( $el )
            }
        }

    }
    */

    
    initImageControlSize( b, $context ){
        let $el = $context ? $context.find( '.image-control-js' ) : $('.image-control-js'), $s, c;

        if ( $el.length > 0 ){
            if ( b ){
                $el.each( ( i, el ) =>{
                    $s = $(el);
                    c = new imageControlSize({
                        $el: $s,
                        main: this.main
                    });
                    $s.data('widget', c );
                }) 

            }
            else{
                this.destroy( $el )
            }
        }
    }

    //-------------------------------------------------- GDPR BAR ---------------------------------------------------------------//
    initGdprBar(){
        const gdpr = new gdprBar({
            main: this.main,
            $el: $('#gdpr-bar'),
            debug: false,
            bypass: true
        });
        gdpr.init( 777 );
    }

    /*
    initWeatherApi(){
        const weather = new weatherApi({
            main: this.main,
            simulate: false //$('body').hasClass( 'is-development' )
        }); 
    }
    */

    
    initGEOLocation(){
        const geo = new geoLocation({
            main: this.main,
            $el: $('.page-menu'),
            debug: false
        });
        this.GEO = geo;
    }

    //------------------------------------------------- UTILS --------------------------------------------------------------------//
    assign( $el, widget ){
        $el.data( 'widget', widget );
    }

    destroy( $el ){
    	let $s, $widget;
        $el.each( ( i, el ) =>{
            $s = $(el);
            $widget = $s.data( 'widget' );
            if ( $widget ){
	            // I don't know if this is necessary ... but let's keep the istance reference (I have to look into Memory garbage)
	            $widget.destroy();
                $widget = null;
	            $s.data('widget', null );     	
            }

        });
    }

}


